import styled, { breakpoints } from '../../../../../styles/theme';
import { StockModelCardDealerInfoStyled } from '../StockModelCardDealerInfoStyled';
import { rem } from 'polished';

export const StockModelCardDealerInfoStyledAP = styled(StockModelCardDealerInfoStyled)`
    .stockModelCard-dealerInfo {
        &--ctaSection {
            background-color: unset !important;
        }
    }
    .dealer-location {
        margin-left: ${rem('25px')};
        margin-right: ${rem('25px')};
        &--info {
            font-size: ${rem('12px')};
        }
    }

    .stockModelCard-dealerInfo--ctaSection > button {
        text-transform: uppercase;
        font-weight: bold;
    }
`;
